import { render } from "./AdminResetForm.vue?vue&type=template&id=0af6bea5"
import script from "./AdminResetForm.vue?vue&type=script&lang=js"
export * from "./AdminResetForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__